import { isDefined, numberOrZero } from "@/utils/utils";
import { Button, Popover } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatLocaleCurrency } from "../../../../../../common/utils/formatUtils";
import { UUID } from "../../../../../../typings/global";
import { DashboardGoal } from "../../../../types";
import { getPercentage } from "../../../../utils";
import { GoalCard } from "../cards/GoalCard";
import { AddGoalModal } from "../modals/AddGoalModal";
import { isCreatedGoal } from "../utils";

type Props = {
  goal?: DashboardGoal;
  year: number;
  agentId: UUID;
};

const MILLION = 1000000;

export const TipperCommissionsWrapper = ({ goal, year, agentId }: Props) => {
  const { t } = useTranslation();

  const [isOpenSetGoalModal, setIsOpenSetGoalModal] = useState(false);

  const hasTarget = isDefined(goal?.targetValue);
  const actualValue = numberOrZero(goal?.actualValue);
  const targetValue = numberOrZero(goal?.targetValue);

  const currentPercentage = isCreatedGoal(goal) ? getPercentage(actualValue, targetValue) : 0;

  return (
    <>
      <GoalCard
        agentId={agentId}
        year={year}
        goal={goal}
        percentage={currentPercentage}
        isGaugeStyle
        label={
          hasTarget ? (
            <Popover content={t("dashboard.goals.helpers.commissionsGoalHint")}>
              {t("dashboard.enums.dashboardGoalType.TIPPER_COMMISSIONS")}
            </Popover>
          ) : (
            <Button onClick={() => setIsOpenSetGoalModal(true)}>{t("dashboard.goals.actions.setTarget")}</Button>
          )
        }
        hasTarget={hasTarget}
        targetLabel={
          hasTarget ? undefined : (
            <div style={{ color: "white" }}>
              <div style={{ fontSize: actualValue >= MILLION ? 24 : 30 }}>{formatLocaleCurrency(actualValue, 0)}</div>
            </div>
          )
        }
        tooltipTitle={
          hasTarget ? (
            <p>
              {formatLocaleCurrency(actualValue, 0)} {t("dashboard.goals.helpers.from")}{" "}
              {formatLocaleCurrency(targetValue, 0)}
            </p>
          ) : undefined
        }
      />

      {goal ? (
        <AddGoalModal
          isOpen={isOpenSetGoalModal}
          onCancel={() => setIsOpenSetGoalModal(false)}
          goalType={goal.type}
          year={year}
          agentId={agentId}
        />
      ) : undefined}
    </>
  );
};
